module.exports = __webpack_public_path__ + "img/banner_info2024.f4fb1dde.png";